export enum UiState {
    Inactive = 'INACTIVE',
    Form = 'FORM',
    InFlight = 'IN_FLIGHT',
    Success = 'SUCCESS',
    Error = 'ERROR',
}
